<template>
  <component :is="as" class="o-linkbox relative" v-bind="$attrs" v-on="$listeners"><slot /></component>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  props: {
    as: {
      default: 'div',
    },
  },
});
</script>

<style lang="scss">
.o-linkbox {
  /* Elevate the links and abbreviations up */
  a[href]:not(.o-linkbox__overlay),
  abbr[title] {
    position: relative;
    z-index: 1;
  }
}
</style>
